<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><b>Praise for Michael Slade</b></p>
<p class="noindent"><br/> </p>
<p class="noindent_sp">“Michael Slade's books are blood-chilling, spine-tingling, gut-wrenching, stomach-churning, and a much closer look at the inside of a maniac's brain than most people would find comfortable—but always riveting.” </p>
<p class="right"> —Diana Gabaldon,  #1 <i>New York Times</i>–bestselling author of the Outlander series</p>
<p class="noindent"><br/> </p>
<p class="noindent">“Crime writer Michael Slade is the real deal! As a trial lawyer, Slade knows psycho killers, sex predators, and their horrific crimes inside out. As a Mountie, I worked sex crimes and led a team of ViCLAS psycho-hunters for seven years. If reading Slade makes you react, ‘Wow! Serial killers don't really do that to people, do they?’, I can tell you, yes, they do.”  </p>
<p class="right"> —RCMP Staff Sergeant Christine Wozney (ret.), CO of the Violent Crime Linkage Analysis team (West Coast)</p>
<p class="noindent"><br/> </p>
<p class="center"><b>Praise for <i>Headhunter</i></b></p>
<p class="noindent"><br/> </p>
<p class="noindent_sp">“<i>Headhunter</i> stunned me. It’s really good.”</p>
<p class="right"> —Alice Cooper</p>
<p class="noindent"><br/> </p>
<p class="noindent">“A real chiller! The most gruesome I have ever read.” </p>
<p class="right"> —Robert Bloch, author of <i>Psycho</i>, on the original edition of <i>Headhunter</i></p>
<p class="noindent"><br/> </p>
<p class="noindent">“First rate, compelling, nerve-tingling. A novel of sex, death, and the macabre. Extraordinarily vivid. A thinking man’s <i>Texas Chainsaw Massacre</i>. It works exceptionally well. One of the novel’s more noteworthy achievements is a complex structure of flashback sequences and parallel story lines, which allows Slade to artfully play the old genre game of posing various solutions to the identity of the killer.” </p>
<p class="right"> —<i>The Vancouver Sun</i></p>
<p class="noindent"><br/> </p>
<p class="noindent">“Full of spooky weird stuff, fast-paced shoot-em-up action, and a surprise ending. There are twists and turns, false leads and sudden shocks. You probably won't be able to figure out whodunit." </p>
<p class="right"> —<i>The Gazette</i>, Montreal</p>
<p class="noindent"><br/> </p>
<p class="noindent">“WARNING: Not for the squeamish. A novel so terrifying it will haunt your dreams for weeks.” </p>
<p class="right"> —<i>Book of the Month Club Magazine</i></p>
<p class="noindent"><br/> </p>
<p class="noindent">“An encyclopedia of weirdness. There’s enough assorted kinkiness, perversion, and psychosis in <i>Headhunter</i> to fill a dozen insane asylums. The setting is refreshing, with real suspense and interesting characters.” </p>
<p class="right"> —<i>Asbury Park Press</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise.vue?337419de